/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { type HttpResponse, I18nService } from '@dm/core';
import { type Lun, type MappingView } from 'app/common/types/mo';
import { DataTypeId } from 'app/feature/share/global-search/global-infigo/const';
import { type Observable, forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InfigoService } from '../../../infigo.service';
import { RefreshComponent } from '../../RefreshComponent';
import { MappingTableComponent } from '../../resource-table/mapping-table/mapping-table.component';
import { MemberLunTableComponent } from '../../resource-table/member-lun-table/member-lun-table.component';

@Component({
    selector: 'app-lun-group-resource',
    templateUrl: './lun-group-resource.component.html',
    styleUrls: ['../../resource.scss'],
})
export class LunGroupResourceComponent extends RefreshComponent {
    @Input() data;
    @ViewChild('memberLunTable', { static: true }) memberLunTable: MemberLunTableComponent;
    @ViewChild('mappingTable', { static: true }) mappingTable: MappingTableComponent;
    firstTabItem = this.i18n.get('storage.lunGroup_view_menberLUN_lab');
    defaultActiveItem = this.firstTabItem;
    secondTabItem = `${this.i18n.get('common.hostGroups_title')}/${this.i18n.get('common.hosts_title')}`;
    lunGroupId;
    lunList: Lun[] = [];
    mappingList: MappingView[] = [];
    $destroy = new Subject<void>();
    loading = true;
    propName = 'data';

    constructor(private i18n: I18nService, public infigoService: InfigoService, public changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    requestInfo(): Observable<any> {
        return forkJoin([this.getAssociateLuns(), this.getAssociateHostGroup()]);
    }

    handleRequest(value: any): void {
        const [luns, host] = value;
        this.lunList = luns.data;
        this.mappingList = host.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }

    // 获取LUN成员
    getAssociateLuns(): Observable<HttpResponse> {
        this.lunGroupId = this.data && (this.data.ID || this.data.actionParams);
        return this.infigoService.getAssociateLun(this.lunGroupId)
            .pipe(takeUntil(this.$destroy));
    }

    // 获取LUN组关联的关联关系 - 主机组
    getAssociateHostGroup(): Observable<HttpResponse> {
        return this.infigoService.getAssociateMappings(DataTypeId[this.data.type], this.lunGroupId, [
            [
                { field: 'hostGroupId', matchMode: '!!', value: '-1' },
            ],
            [
                { field: 'hostId', matchMode: '!!', value: '-1' },
            ],
        ])
            .pipe(takeUntil(this.$destroy));
    }
}
